import { useEffect } from "react";

export const SITE_URL = "https://fridacicekcilik.com.tr";
export const SITE_NAME = "Frida Çiçekçilik";
export const DEFAULT_TITLE = "Frida Çiçekçilik | Dörtyol Hatay - Aynı Gün Çiçek Teslimatı, Türkiye Geneli Kargo";
export const DEFAULT_DESCRIPTION =
  "Frida Çiçekçilik - Hatay merkezli premium çiçekçi. Aynı gün teslimat, taze çiçek garantisi, 7/24 hizmet. " +
  "Hatay, Adana, Osmaniye, Gaziantep'e aynı gün, Türkiye'nin her iline kargo ile çiçek gönderimi. 0532 461 04 31";
export const DEFAULT_IMAGE = "https://images.unsplash.com/photo-1572454591674-2739f30d8c40?w=1200&q=80";

function setNamedMeta(name, content) {
  let el = document.head.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setPropMeta(property, content) {
  let el = document.head.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/**
 * Sayfa başına title/meta/canonical/OG/Twitter/JSON-LD — index.html'deki
 * STATİK etiketleri (yalnızca JS hiç çalışmadan önceki an ve JS çalıştırmayan
 * botlar için bir düşüş/fallback) DOM üzerinde YERİNDE günceller.
 *
 * NEDEN React 19'un yerleşik <title>/<meta> "hoisting" özelliği yerine bu
 * imperatif yaklaşım kullanılıyor: React yalnızca KENDİ render ettiği
 * etiketler arasında tekilleştirme (dedupe) yapar — index.html'deki statik
 * bir <meta name="description"> React'in hiç haberi olmayan bir düğümdür,
 * bu yüzden React onun YANINA ikinci bir description etiketi daha ekler
 * (üzerine yazmaz). Sonuç: sayfada AYNI ANDA iki tane meta description
 * olur, arama motorları/SEO denetim araçları bunu "birden fazla meta
 * description" hatası olarak işaretler ve hangisinin kullanılacağı
 * tarayıcıdan tarayıcıya değişir. Bu bileşen bunun yerine index.html'deki
 * MEVCUT etiketi bulup içeriğini değiştirir — her zaman TEK bir etiket olur.
 * (<title> için React'in dahili davranışı `document.title` üzerinden doğru
 * çalışsa da, tutarlılık ve ham DOM'u okuyan botlar için aynı yöntem
 * kullanılır.)
 */
export default function Seo({
  title,
  description = DEFAULT_DESCRIPTION,
  path,
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
  jsonLd,
}) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
    const canonical = path ? `${SITE_URL}${path}` : null;

    document.title = fullTitle;

    setNamedMeta("description", description);
    setNamedMeta("robots", noindex ? "noindex, nofollow" : "index, follow");

    if (canonical) {
      let canonicalEl = document.head.querySelector('link[rel="canonical"]');
      if (!canonicalEl) {
        canonicalEl = document.createElement("link");
        canonicalEl.setAttribute("rel", "canonical");
        document.head.appendChild(canonicalEl);
      }
      canonicalEl.setAttribute("href", canonical);
    }

    setPropMeta("og:type", type);
    setPropMeta("og:site_name", SITE_NAME);
    setPropMeta("og:locale", "tr_TR");
    setPropMeta("og:title", fullTitle);
    setPropMeta("og:description", description);
    if (canonical) setPropMeta("og:url", canonical);
    setPropMeta("og:image", image);

    setNamedMeta("twitter:card", "summary_large_image");
    setNamedMeta("twitter:title", fullTitle);
    setNamedMeta("twitter:description", description);
    setNamedMeta("twitter:image", image);

    // Sayfaya özel yapılandırılmış veri (Product/Article/BreadcrumbList/FAQPage)
    // — her sayfa geçişinde bir önceki sayfanın şemaları temizlenip yenisi eklenir.
    document.head.querySelectorAll('script[data-seo-jsonld="1"]').forEach((s) => s.remove());
    const schemas = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
    schemas.forEach((schema) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-jsonld", "1");
      s.textContent = JSON.stringify(schema);
      document.head.appendChild(s);
    });
  }, [title, description, path, image, type, noindex, jsonLd]);

  return null;
}
